import { Icon, IconSet } from '@postscript/components';
import { dynamicImageTagsDict } from 'components/flowBuilder/constants/tags';
import { Tag } from 'components/flowBuilder/types/tags';
import NonrepresentationalMediaPreview from 'components/messagePreview/components/NonrepresentationalMediaPreview';
import styled from 'styled-components';

const dynamicImageTags: Tag[] = Object.values(dynamicImageTagsDict).flat();

export const getDynamicImageTag = (mediaUrl: string) =>
  dynamicImageTags.find(({ key }) => key === mediaUrl) ?? null;

const StyledIcon = styled(Icon)`
  transform: rotate(-10deg);

  path {
    stroke: var(--flow-builder-dynamic-image-icon);
  }
`;

interface DynamicImagePreviewProps {
  description: string;
}

const DynamicImagePreview = ({
  description,
}: DynamicImagePreviewProps): JSX.Element => {
  return (
    <NonrepresentationalMediaPreview
      description={description}
      title="Dynamic Photo"
      icon={<StyledIcon component={IconSet.Photo} />}
    />
  );
};

export default DynamicImagePreview;
